<ng-container *ngIf="documentList">
  <!-- Small and medium viewport -->
  <div class="d-block d-lg-none">
    <mobile-table-default [tableData]="documentList" [displayedColumns]="columnsToDisplay"></mobile-table-default>
  </div>

  <!-- Large viewport -->
  <div class="d-none d-lg-block">
    <h2 class="element-title text-truncate" translate="Request.Status.Documents"></h2>
    <desktop-default-table [tableData]="documentList" [displayedColumns]="columnsToDisplay"></desktop-default-table>
  </div>
</ng-container>